module.exports = __webpack_public_path__ + "static/media/rabbit-fast.9dbe557d.svg";